import { FormList, HeaderTitle, Operation, Thumbnails } from '@/components';
import { deleteTrainCategory, getTrainCategoryList, updateTrainCategory } from '@/api';
import { st_train } from '@/utils/statetype';
import { toDateTime } from '@/utils/utils';
import { Button, message, Table, Switch } from 'antd';
import React, { useState } from 'react';
import { useTable } from '@/hooks';
import moment from 'moment';
import TrainCategoryEdit from './components/TrainCategoryEdit';

const { statusObj } = st_train;
function Train() {
  const [query, setQuery] = useState({});
  const [datas, setDatas] = useState({});
  const [visible, setVisible] = useState(false);

  const columns = {
    id: '编号',
    name: '标题',
    NOINDEX_operation: {
      title: '操作',
      fixed: 'right',
      render: e => (
        <Operation
          listData={{
            update: () => {
              const { ...prop } = e;
              setVisible(true);
              setDatas({
                ...prop,
              });

            },
            delete: () => {
              deleteTrainCategory({
                body: {
                  id: e.id,
                },
              }).then(() => {
                message.success('删除成功');
                flagFn(true);
              });
            },
          }}
        />
      ),
    },
  };

  const { tableProps, flagFn } = useTable({
    columns,
    API: getTrainCategoryList,
    isInit: false,
    params: {
      query,
    },
  });

  const formData = [
    {
      id: 'id',
      label: '编号',
    },
  ];

  const changeQuery = (value = {}) => {
    setQuery(value);
    flagFn(true);
  };

  return (
    <>
      <HeaderTitle />
      <FormList
        formData={formData}
        changeQuery={changeQuery}
        extraRender={
          <Button type="primary" disabled={!global.isOperable} onClick={() => setVisible(true)}>
            添加
          </Button>
        }
      />
      <Table {...tableProps} />
      <TrainCategoryEdit
        data={datas}
        visible={visible}
        onChange={res => {
          if (res) flagFn();
          setVisible(false);
          setDatas({});
        }}
      />
    </>
  );
}

export default Train;
